import * as React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { FormControl, FormHelperText } from "@material-ui/core";
import SearchBarFilter from "../../components/_Layout/Search/SearchBarFilter";

const useStyles = makeStyles((theme: any) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.background.paper,

      "& .MuiCardContent-root": {
        paddingTop: theme.spacing(0),
        paddingLeft: theme.spacing(2),
      },
    },
    "& .makeStyles-content": {
      backgroundColor: theme.palette.background.paper,
    },

    filter: {
      width: "10%",
      padding: theme.spacing(1),
      display: "inline-block",
    },
    searchBarContainer: {
      backgroundColor: theme.palette.site.secondary,
      borderRadius: 20,
      paddingLeft: "10px !important",
      fontSize: 13,
      width: "250px", 
      fontWeight: theme.typography.fontWeightBold,
      color: theme.palette.black,
      paddingTop: "2.5px !important",
      paddingBottom: "2.5px !important",
      marginLeft: theme.spacing(3),
    },
    studentSearchContainer: {
      borderBottom: "1px solid #000",
      color: theme.palette.black,
      paddingTop: "2.5px !important",
      paddingBottom: "2.5px !important",
    },
    errorUnderline: {
      "& .MuiInput-underline:before": {
        borderBottom: "2px solid red", 
      },
      "& .MuiInput-underline:hover:before": {
        borderBottom: "2px solid red", 
      },
      "& .MuiInput-underline:after": {
        borderBottom: "2px solid red", 
      },
    },
  })
);

interface IModel {
  studentNameBadgeId?: string;
  studentName?: string;
}

interface IStudentNameBadgeIDFilterProps {
  model: IModel;
  show?: boolean;
  setModel: (values: IModel) => void;
  report?: boolean;
  placeHolder?: string;
  error?: boolean; 
  helperText?: string; 
}

const StudentNameBadgeIDFilterAttendMod = (props: IStudentNameBadgeIDFilterProps) => {
  const classes = useStyles({});
  const { model, setModel, error, helperText } = props;

  if (props.show) {
    return (
      <FormControl
        error={error}
        fullWidth
      >
        <div
          className={`${props.report ? classes.studentSearchContainer : classes.searchBarContainer} ${
            error ? classes.errorUnderline : ""
          }`}
        >
          <SearchBarFilter
            report={props.report}
            onSelect={(data?: any, studentName?: string) =>
              data &&
              data.stuEnrollId &&
              data.stuEnrollId !== model.studentNameBadgeId &&
              studentName &&
              setModel({ studentNameBadgeId: data.stuEnrollId, studentName })
            }
            placeholder={(model && model.studentName) || props.placeHolder}
          />
        </div>
        {helperText && (
          <FormHelperText>{helperText}</FormHelperText> 
        )}
      </FormControl>
    );
  } else {
    return <div className={classes.root}></div>;
  }
};

export default StudentNameBadgeIDFilterAttendMod;
